// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"49fe9561","977":"85072650"}[chunkId] + ".chunk.js";
};